import React from "react";

const DottedLoadingData = ({ withText }) => {
  return (
    <div className="vh-100">
      {withText == "false" ? (
        ""
      ) : (
        <div
          className="text-center position-fixed"
          style={{ left: "50%", marginLeft: "-75px" }}
        >
          در حال دریافت اطلاعات ...
        </div>
      )}

      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
export default DottedLoadingData;
